export function getLegacyPlannerLocationValue({ coordinates, direction, locationField, field, userPositionString }) {
  if (coordinates) { return coordinates }
  if (locationField === field) { return userPositionString }

  return direction
}

export function formatLegacyPlannerUserPosition(userPosition) {
  return `${userPosition.lat}, ${userPosition.lng}`
}

export function buildLegacyPlannerTemporalReferenceParams({ showTimeDatePicker, temporalReference, formattedDate }) {
  if (!showTimeDatePicker) { return {} }

  return {
    arrivalTime: temporalReference === 'arrival' ? formattedDate : null,
    departureTime: temporalReference === 'arrival' ? null : formattedDate
  }
}

export function getLegacyPlannerMunicipalityBoundPoints(municipality) {
  const { lat, lng } = municipality.geo
  const {
    upper_left_bound_lat,
    upper_left_bound_lng,
    lower_right_bound_lat,
    lower_right_bound_lng
  } = municipality

  if (
    upper_left_bound_lat &&
    upper_left_bound_lng &&
    lower_right_bound_lat &&
    lower_right_bound_lng
  ) {
    return {
      upperLeft: { lat: upper_left_bound_lat, lng: upper_left_bound_lng },
      lowerRight: { lat: lower_right_bound_lat, lng: lower_right_bound_lng }
    }
  }

  return {
    upperLeft: { lat, lng },
    lowerRight: { lat, lng }
  }
}

export function buildLegacyPlannerDirectionState(fieldName, place) {
  const direction = `${place.formatted_address}`
  const coordinates = `${place.geometry.location.lat()},${place.geometry.location.lng()}`

  if (fieldName === 'originDirection') {
    return {
      originDirection: direction,
      originCoordinates: coordinates
    }
  }

  return {
    destinationDirection: direction,
    destinationCoordinates: coordinates
  }
}

export function getLegacyPlannerLocationFieldSelection(target, userPosition, currentLocationField) {
  return userPosition ? target : currentLocationField
}

export function getLegacyPlannerToggledLocationField(locationField) {
  if (locationField === 'origin') { return 'destination' }
  if (locationField === 'destination') { return 'origin' }

  return locationField
}

export function buildLegacyPlannerDatepickerConfig() {
  return {
    enableTime: false,
    dateFormat: 'Y-m-d',
    altInput: true,
    altFormat: 'D, j M',
    disableMobile: true
  }
}

export function getLegacyPlannerFullErrorKey(error, { title }) {
  const titlePart = title ? 'Title' : ''

  return `planner.errors.${error}${titlePart}`
}

export function getLegacyPlannerSearchErrorPart(error, { title, hasTranslation, translate, camelCase }) {
  const formattedErrorName = camelCase(error)
  const errorKey = getLegacyPlannerFullErrorKey(formattedErrorName, { title })

  return hasTranslation(errorKey) ? translate(errorKey) : translate(getLegacyPlannerFullErrorKey('generic', { title }))
}

export function buildLegacyPlannerSearchError(error, { hasTranslation, translate, camelCase }) {
  return {
    title: getLegacyPlannerSearchErrorPart(error, { title: true, hasTranslation, translate, camelCase }),
    message: getLegacyPlannerSearchErrorPart(error, { title: false, hasTranslation, translate, camelCase })
  }
}
